import React, { useContext, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../utils/authProvider";
import { Box, Grid, IconButton, Link } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { signinRedirect } from "../services/userService";
import { toast } from "react-hot-toast";

const Login = () => {
    const user = useSelector((state) => state.auth.user);
    const userManager = useContext(AuthContext);

    const { fromAutomaticLogout } = useParams();

    useEffect(() => {
        if (fromAutomaticLogout) {
            toast.error("Automatic logout!");
        }
    }, [fromAutomaticLogout]);

    const handleLogin = () => {
        signinRedirect(userManager);
    };

  return user ? (
    <Navigate to={"/"} />
  ) : (
    <Box sx={{ minHeight: "95vh", display: "flex" }}>
      <Container
        component="main"
        maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            gap: 2, // spazio verticale tra elementi
          }}
        >
          {/* Header con logo Kering */}
          <Grid container sx={{ mb: 4 }} justifyContent="center">
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <img
                src={require("../img/kering_logo.png")}
                style={{ width: "20%", maxWidth: 200, minWidth: 120 }}
                alt="Kering"
              />
            </Grid>
          </Grid>

          {/* Logo centrale */}
          <img
            src={require("../img/logo_APEEvo.png")}
            alt="Evo Reverse"
            style={{ width: "20%", maxWidth: 200, minWidth: 120 }}
          />

          {/* Form / Bottone */}
          <Box component="form" noValidate sx={{ mt: 1, width: "30%" }}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={8} md={6}>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  onClick={handleLogin}
                  sx={{ mt: 3, mb: 2 }}
                >
                  Log In
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
